import Vue from 'vue';
import Router from 'vue-router';
import preciseReview from "./modules/preciseReview";
import demos from './demo.js';
import tarAdminRouter from './tar_admin.js';

Vue.use(Router);

// 懒加载
const LoginView = resolve => require(['@/components/common/login.vue'], resolve);
//二维码分享页面
const ShareView = resolve => require(["@/components/wxShare/index.vue"], resolve);
const HomePage = resolve => require(['@/components/common/homepage.vue'], resolve);
const guide = resolve => require(['@/components/common/guide.vue'], resolve);
const A0003 = resolve => require(['@/components/a0003/a0003.vue'], resolve);
const StudentDataAnalysis = resolve => require(['@/components/a0003/studentDataAnalysis.vue'], resolve);
const A0004 = resolve => require(['@/components/a0004/a0004.vue'], resolve);
const ProActiveView = resolve => require(['@/components/common/pro-active.vue'], resolve);
const ERR501 = resolve => require(['@/components/common/501.vue'], resolve);
const ERR404 = resolve => require(['@/components/common/404.vue'], resolve);
const ERR401 = resolve => require(['@/components/common/401.vue'], resolve);
const D000305 = resolve => require(['@/components/d0003/d000305.vue'], resolve);

/** 素材部分 */
const B000201 = resolve => require(['@/components/b0002/b000201.vue'], resolve);
const B000202 = resolve => require(['@/components/b0002/b000202.vue'], resolve);
const C000101 = resolve => require(['@/components/c0001/c000101.vue'], resolve);
const C000201 = resolve => require(['@/components/c0002/c000201.vue'], resolve);
const C000202 = resolve => require(['@/components/c0002/c000202.vue'], resolve);
/** 教学设计部分 */
const D000101 = resolve => require(['@/components/d0001/d000101.vue'], resolve);
const D000102 = resolve => require(['@/components/d0001/d000102.vue'], resolve);
const D000103 = resolve => require(['@/components/d0001/d000103.vue'], resolve);
const D000104 = resolve => require(['@/components/d0001/d000104.vue'], resolve);
/** 知识点选择**/
const D000107 = resolve => require(['@/components/d0001/d000107.vue'], resolve);
/** 新建教学设计**/
const D000108 = resolve => require(['@/components/d0001/d000108.vue'], resolve);
/** 预览教案**/
const D000113 = resolve => require(['@/components/d0001/d000113.vue'], resolve);
/** 课后作业部分 */
const D000201 = resolve => require(['@/components/d0002/d000201.vue'], resolve);
const D000202 = resolve => require(['@/components/d0002/d000202.vue'], resolve);
const D000203 = resolve => require(['@/components/d0002/d000203.vue'], resolve);
const D000204 = resolve => require(['@/components/d0002/d000204.vue'], resolve);
const D000205 = resolve => require(['@/components/d0002/d000205.vue'], resolve);
const D000206 = resolve => require(['@/components/d0002/d000206.vue'], resolve);
const D000207 = resolve => require(['@/components/d0002/d000207.vue'], resolve);
const D000208 = resolve => require(['@/components/d0002/d000208.vue'], resolve);
const D000210 = resolve => require(['@/components/d0002/d000210.vue'], resolve);
const D000211 = resolve => require(['@/components/d0002/d000211.vue'], resolve);
/** 课后作业报告部分 */
const D000301 = resolve => require(['@/components/d0003/d000301.vue'], resolve);
/** 测评信息查阅部分 */
const D000306 = resolve => require(['@/components/d0003/d000306.vue'], resolve);
const D000302 = resolve => require(['@/components/d0003/d000302.vue'], resolve);
const D000307 = resolve => require(['@/components/d0003/d000307.vue'], resolve);
const D000308 = resolve => require(['@/components/d0003/d000308.vue'], resolve);
/** 授课部分 */
const E000101 = resolve => require(['@/components/e0001/e000101.vue'], resolve);
//import E000201 from "@/components/e0002/e000201.vue";
const E000201 = resolve => require(['@/components/e0002/e000201.vue'], resolve);
const E000212 = resolve => require(['@/components/e0002/e000212.vue'], resolve);
const E000213 = resolve => require(['@/components/e0002/e000213.vue'], resolve);

/** 考勤部分 */
const WorkAttendance = resolve => require(['@/components/common/teaching/work-attendance.vue'], resolve);
const AutoAttendance = resolve => require(['@/components/common/teaching/auto-attendance.vue'], resolve);

/** 票据流转 */
const F000101 = resolve => require(['@/components/f0001/f000101.vue'], resolve);
const F000102 = resolve => require(['@/components/f0001/f000102.vue'], resolve);
const F000201 = resolve => require(['@/components/f0002/f000201.vue'], resolve);

/** 未激活页 */
const NOACCESS = resolve => require(['@/components/common/Noaccess.vue'], resolve);
const LICENSE = resolve => require(['@/components/common/sys/license.vue'], resolve);
const ACTIVE = resolve => require(['@/components/common/sys/active.vue'], resolve);

/** 数据分析 */
const DataAnalysis = resolve => require(['@/components/dataAnalysis/dataAnalysis.vue'], resolve);
/** 全景数据 */
const PanoramicData = resolve => require(['@/components/dataAnalysis/panoramicData.vue'], resolve);
/** 课程数据 */
const CourseData = resolve => require(['@/components/e0002/courseData.vue'], resolve);
/** 历史课程数据 */
const HistoryCourseData = resolve => require(['@/components/e0002/historyCourseData.vue'], resolve);

/** 题库 */
const ExerBank = resolve => require(['@/components/exerBank/exerBank.vue'], resolve);
/** 试题篮 */
const ExerBasket = resolve => require(['@/components/exerBank/exerBasket.vue'], resolve);
/** 试题篮 */
const ExerBankView = resolve => require(['@/components/exerBank/exerBankView.vue'], resolve);

/** 题库 */
const Exam = resolve => require(['@/components/exam/exam.vue'], resolve);
const ExamView = resolve => require(['@/components/exam/view.vue'], resolve);
const ExamBank = resolve => require(['@/components/exam/examBank.vue'], resolve);
const EditPaperExercise = resolve => require(['@/components/exam/editPaperExercise.vue'], resolve);
const ExamBankView = resolve => require(['@/components/exam/examBankView.vue'], resolve);
/** 异常日志**/
const Exception = resolve => require(['@/components/exception/index.vue'], resolve);


/** 数据报告*/
const DataReport = resolve => require(['@/components/dataReport/index.vue'], resolve);
/** 课程管理**/
const CourseManagement = resolve => require(['@/components/courseManagement/courseManagement.vue'], resolve);
/** 校本资源库 **/
const SchoolResourceCenter = resolve => require(['@/components/schoolResourceCenter/index.vue'], resolve);
/** 在线精品课 **/
const BoutiqueCourse = resolve => require(['@/components/boutiqueCourse/index.vue'], resolve);
const BoutiqueCourseInfo = resolve => require(['@/components/boutiqueCourse/boutiqueCourseInfo.vue'], resolve);
const BoutiqueCourseContent = resolve => require(['@/components/boutiqueCourse/boutiqueCourseContent.vue'], resolve);
const TeachingDesignPreview = resolve => require(['@/components/boutiqueCourse/teachingDesignPreview.vue'], resolve);

/**
 * V4.2 在线精品课
 */
const excellentCourse = resolve => require(['@/components/excellentCourse/index.vue'], resolve);

const teachingResources = resolve => require(['@/components/excellentCourse/teachingResources.vue'], resolve);
/** 精品课老师统计 */
const CourseStatistic = resolve => require(['@/components/excellentCourse/components/courseStatistic.vue'], resolve);
/**课程预览 */
const coursePreview = resolve => require(['@/components/excellentCourse/coursePreview.vue'], resolve);
/** 课程介绍**/
const CourseIntroduction = resolve => require(['@/components/excellentCourse/courseIntroduction/index.vue'], resolve);

/** 学生课程学校资料列表 */
const StudentStudyProgress = resolve => require(['@/components/excellentCourse/student/studentStudyProgress.vue'], resolve);

/** 教案预览**/
const CourseCase = resolve => require(['@/components/excellentCourse/courseIntroduction/components/courseCase/courseCase.vue'], resolve);

/** 学生课程信息**/
const StudentCourse = resolve => require(['@/components/excellentCourse/student/studentCourse.vue'], resolve);

const WebOffice = resolve => require(['@/components/excellentCourse/webOffice.vue'],resolve);

const videoExerGen = resolve => require(['@/components/excellentCourse/videoQuizGen'],resolve);

const addVideoExer = resolve => require(['@/components/excellentCourse/videoQuizGen/components/addVideoExer'],resolve);

const relatedVideoExer = resolve => require(['@/components/excellentCourse/videoQuizGen/components/relatedVideoExer'],resolve);

export default new Router({
    // mode:'history',
    //dist:'/history',
    routes: [
        ...demos,
        {path: '/', name: 'Login', component: LoginView},
        {path: "/wxShare", name: "ShareView", component: ShareView},
        {path: '/501', name: '501', component: ERR501},
        {path: '/404', name: '404', component: ERR404},
        {path: '/401', name: '401', component: ERR401},
        // 产品激活页面
        {path: '/sa/active', name: 'ProductActive', component: ProActiveView},
        //指导页
        {path: '/guide', name: 'guide', component: guide},
        // 班级管理
        {
            path: '/a0003', name: 'A0003-Class-Management', component: A0003, meta: {keepAlive: true, level: 1},
            beforeEnter(to, from, next) {
                // 如果是从特定页面进入那么所有条件应该重置
                if (from.path === '/homepage') {
                    to.params.clear = true;
                    to.params.componentName = 'A0003';
                }
                next()
            }
        },
        // 学生课堂数据
        {path: '/studentDataAnalysis', name: 'StudentDataAnalysis', component: StudentDataAnalysis},
        // 学生管理
        {path: '/a0004/:id/:name/:isMine', name: 'A0004', component: A0004},

        /** 素材管理部分 */
        // 素材列表页面
        {
            path: '/b000201', name: 'B000201', component: B000201, meta: {keepAlive: true, level: 1},
            beforeEnter(to, from, next) {
                // 如果是从特定页面进入那么所有条件应该重置
                if (from.path === '/homepage' || from.path === '/f000101') {
                    to.params.clear = true;
                    to.params.componentName = 'ResourceList';
                }
                next()
            }
        },
        // 素材新增/修改页面
        {path: '/b000202', name: 'B000202', component: B000202},

        /** 试题管理部分 */
        // 题库列表
        {path: '/c000101', name: 'C000101', component: C000101},
        // 习题列表页面
        {path: '/c000201/:id', name: 'C000201', component: C000201},
        // 新增习题页面
        {path: '/c000202/:bankId', name: 'C000202', component: C000202},

        /** 教学设计部分 */
        // 教学设计列表页面
        {
            path: '/d000101', name: 'D000101', component: D000101, meta: {keepAlive: true, level: 1},
            beforeEnter(to, from, next) {
                // 如果是从特定页面进入那么所有条件应该重置
                if (from.path === '/homepage') {
                    to.params.clear = true;
                    to.params.componentName = 'D000101';
                }
                next()
            }
        },
        // 教学设计新增或修改页面
        {path: '/d000102', name: 'D000102', component: D000102},
        // ppt编辑器页面
        {path: '/d000103/:id', name: 'D000103', component: D000103},
        // ppt预览页面
        {path: '/d000104/:id', name: 'D000104', component: D000104},
        // 新建教学设计
        //{ path: '/d000108/:id', name: 'D000108C', component: D000108 },
        {path: '/d000108/:id/:teachingDesignId/:type/:isMine', name: 'D000108', component: D000108},
        // 预览教案
        {path: '/d000113/:teachingDesignId', name: 'D000113', component: D000113},
        // 知识点选择
        // { path: '/d000107/:id', name: 'D000107C', component: D000107 },
        {path: '/d000107/:id/:teachingDesignId/:type', name: 'D000107', component: D000107},
        /** 课后作业部分 */
        // 课后作业列表页面
        {path: '/d000201', name: 'D000201', component: D000201},
        // 教学设计课后作业页面
        {path: '/d000202', name: 'D000202', component: D000202},
        // 教学设计课后作业选题页面
        {path: '/d000203', name: 'D000203', component: D000203},
        // 教学设计课后作业附件页面
        {path: '/d000204', name: 'D000204', component: D000204},
        // 教学设计课后作业附件素材页面
        {path: '/d000205', name: 'D000205', component: D000205},
        // 教学设计课后作业附件素材页面
        {path: '/d000206', name: 'D000206', component: D000206},
        // 作业编辑页面
        {path: '/d000207', name: 'D000207', component: D000207},
        // 作业设置页面
        {path: '/d000208', name: 'D000208', component: D000208},
        // 编辑作业习题
        {path: '/d000210', name: 'D000210', component: D000210},
        // 阅卷
        {path: '/d000211', name: 'D000211', component: D000211},
        /** 课后作业报告部分 */
        // 课后作业报告页面
        {
            path: '/d000301', name: 'D000301', component: D000301, meta: {keepAlive: true, level: 1},
            beforeEnter(to, from, next) {
                // 如果是从特定页面进入那么所有条件应该重置
                if (from.path === '/d000201') {
                    to.params.clear = true;
                    to.params.componentName = 'D000301';
                }
                next()
            }
        },
        /** 测评信息查阅部分 */
        {path: '/d000306', name: 'D000306', component: D000306},
        {path: '/d000307', name: 'D000307', component: D000307},
        {path: '/d000308', name: 'D000308', component: D000308},
        /** 授课部分 */
        {
            path: '/e000101', name: 'E000101', component: E000101, meta: {keepAlive: true, level: 1},
            beforeEnter(to, from, next) {
                // 如果是从特定页面进入那么所有条件应该重置
                if (from.path === '/homepage') {
                    to.params.clear = true;
                    to.params.componentName = 'e000101-wrapper';
                }
                next()
            }
        },
        {path: '/e000201/:glId/:tdId', name: 'E000201', component: E000201},
        {path: '/e000213/:glId/:tdId', name: 'E000213', component: E000213},

        /** 考勤部分 */
        // 考勤页面
        {path: '/work-attendance', name: 'Work-attendance', component: WorkAttendance},
        {path: '/auto-attendance', name: 'Auto-attendance', component: AutoAttendance},

        /**
         * 学生查阅页面跳转
         */
        {path: '/d000305', name: 'D000305', component: D000305},

        /** 票据流转 */
        {
            path: '/f000101', name: 'F000101', component: F000101, meta: {keepAlive: true, level: 1},
            beforeEnter(to, from, next) {
                // 如果是从特定页面进入那么所有条件应该重置
                if (from.path === '/b000201') {
                    to.params.clear = true;
                    to.params.componentName = 'f000101-wrapper';
                }
                next()
            }
        },
        {path: '/f000102', name: 'F000102', component: F000102},
        {path: '/f000201', name: 'F000201', component: F000201},
        /** 未授权跳转页面 */
        {path: '/noaccess', name: 'NOACCESS', component: NOACCESS},
        {path: '/license', name: 'LICENSE', component: LICENSE},
        {path: '/active', name: 'ACTIVE', component: ACTIVE},


        // TO DELETE
        {path: '/e000212', name: 'E000212', component: E000212},

        // 数据分析
        {path: '/dataAnalysis', name: 'DataAnalysis', component: DataAnalysis},
        // 全景数据
        {path: '/panoramicData', name: 'PanoramicData', component: PanoramicData},
        // 课程数据
        {path: '/courseData', name: 'CourseData', component: CourseData},
        //历史课程数据
        {path: '/historyCourseData/:glId', name: 'HistoryCourseData', component: HistoryCourseData},
        //历史课程数据
        {path: '/exerBank', name: 'ExerBank', component: ExerBank},
        //历史课程数据
        {path: '/exerBankView', name: 'ExerBankView', component: ExerBankView},
        //历史课程数据
        {path: '/exerBasket', name: 'ExerBasket', component: ExerBasket},

        //测评试卷
        {path: '/exam', name: 'Exam', component: Exam},
        //试卷详情
        {path: '/viewPaper', name: 'ExamView', component: ExamView},
        //组卷详情
        {path: '/examBank', name: 'ExamBank', component: ExamBank},

        {path: '/examBankView', name: 'ExamBankView', component: ExamBankView},
        //试卷编辑试题
        {path: '/editPaperExercise', name: 'EditPaperExercise', component: EditPaperExercise},

        // 数据报告
        {path: '/dataReport', name: 'DataReport', component: DataReport},

        // 课程管理
        {path: '/courseManagement', name: 'CourseManagement', component: CourseManagement},
        //在线精品课
        {path: '/boutiqueCourse', name: 'BoutiqueCourse', component: BoutiqueCourse},
        {path: '/boutiqueCourseInfo', name: 'BoutiqueCourseInfo', component: BoutiqueCourseInfo},
        {path: '/boutiqueCourseContent', name: 'BoutiqueCourseContent', component: BoutiqueCourseContent},
        {path: '/teachingDesignPreview', name: 'TeachingDesignPreview', component: TeachingDesignPreview},


        // 高效备课
        // 首页
        {
            path: '/homepage',
            name: 'HomePage',
            component: HomePage,
            meta: {
                type: '1'
            },
        },
        // v4.2在线精品课
        {
            path: '/excellent',
            name: 'ExcellentCourse',
            component: excellentCourse,
            redirect: '/excellent/home',
            meta: {type: '2'},
            children: [
                {
                    path: 'home',
                    name: 'ExcellentCourseHome',
                    component: () => import('@/components/excellentCourse/home.vue'),
                    meta: {type: '2'},
                },
                {
                    path: 'personal',
                    name: 'Personal',
                    component: () => import('@/components/excellentCourse/personal.vue'),
                    meta: {type: '2'},
                }
            ]
        },
        // 校本资源库
        {
            path: '/schoolResourceCenter',
            name: 'SchoolResourceCenter',
            component: SchoolResourceCenter,
            meta: {
                type: '4'
            },
        },
        {path: '/courseShow', name: 'coursePreview', component: coursePreview},
        
        // URL参数登录访问课程预览页面
        {path: '/courseUrlLogin', name: 'courseUrlLogin', component: () => import('@/components/excellentCourse/urlLogin.vue')},
        
        {path: '/courseStatistic', name: 'CourseStatistic', component: CourseStatistic},
        //测试文档
        {
            path: '/webOffice',
            name: 'webOffice',
            component: WebOffice
        },
        // 课程介绍
        {
            path: '/courseIntroduction', name: 'CourseIntroduction', component: CourseIntroduction,
            children: [
                {
                    path: 'home',
                    name: 'introduction',
                    component: () => import('@/components/excellentCourse/courseIntroduction/components/courseIntroductionContent.vue'),
                },
                {
                    path: 'jExam',
                    name: 'jExam',
                    component: () => import('@/components/excellentCourse/courseIntroduction/components/jExam/index.vue'),
                },
                {
                    path: 'homeWork',
                    name: 'homeWork',
                    component: () => import('@/components/excellentCourse/courseIntroduction/components/homeWork/homeWork.vue'),
                },
                {
                    path: 'teacherThemeDiscuss',
                    name: 'teacherThemeDiscuss',
                    component: () => import('@/components/excellentCourse/courseIntroduction/components/jThemeDiscuss/teacherThemeDiscuss.vue'),
                },
                // 分享区
                {
                  path: 'teacherShare',
                  name: 'teacherShare',
                  component: () => import('@/components/excellentCourse/courseIntroduction/components/jCourseShare/index.vue'),
                },
                // 分享区详情
                {
                  path: 'teacherShareDetail',
                  name: 'teacherShareDetail',
                  component: () => import('@/components/excellentCourse/courseIntroduction/components/jCourseShare/detail.vue'),
                },
                {
                    path: 'teachingResources',
                    name: 'teachingResources',
                    component: () => import('@/components/excellentCourse/teachingResources.vue'),
                },
                {
                    path: 'report',
                    name: 'report',
                    component: () => import('@/components/excellentCourse/courseIntroduction/components/jThemeDiscuss/report.vue'),
                },
                {
                    path: 'courseStatistic',
                    name: 'courseStatistic',
                    component: () => import('@/components/excellentCourse/components/courseStatistic.vue'),
                },
                {
                    path: 'statisticalDetails',
                    name: 'statisticalDetails',
                    component: () => import('@/components/excellentCourse/courseIntroduction/components/statisticalDetails.vue'),
                },
                {// 教师端课程公告
                    path: 'teacherCourseNotice',
                    name: 'TeacherCourseNotice',
                    component: () => import('@/components/excellentCourse/courseIntroduction/components/teacherCourseNotice.vue')
                },
                {// 课程管理
                    path: 'courseManage',
                    name: 'CourseManage',
                    component: () => import('@/components/excellentCourse/courseIntroduction/components/courseManage.vue')
                },
                {// 课堂教案
                    path: 'courseCase',
                    name: 'CourseCase',
                    component: () => import('@/components/excellentCourse/courseIntroduction/components/courseCase/courseCase.vue')
                },
                {//  互动讨论详情
                    path: 'themeDiscussDetails',
                    name: 'themeDiscussDetails',
                    component: () => import('@/components/excellentCourse/components/themeDiscussDetails.vue')
                },
                {// 章节目录
                    path: 'chapterContents',
                    name: "ChapterContents",
                    component: () => import('@/components/excellentCourse/courseIntroduction/components/chapterContents/chapterContents.vue')
                },
                {
                    path: 'audit',
                    name: 'audit',
                    component: () => import('@/components/excellentCourse/courseIntroduction/components/jThemeDiscuss/audit.vue'),
                },
                // 考核标准设置
                {
                    path: 'examineStandard',
                    name: "examineStandard",
                    component: () => import('@/components/excellentCourse/courseIntroduction/components/courseExamineStandard.vue')
                }
            ]
        },

      // 视频试题相关
      {
        path: '/videoExerGen', name: 'videoExerGen', component: videoExerGen,
      },

      // 新增视频相关试题
      {
        path: '/addVideoExer', name: 'addVideoExer', component: addVideoExer,
      },

      // 新增视频相关试题
      {
        path: '/relatedVideoExer', name: 'relatedVideoExer', component: relatedVideoExer,
      },


        {
            path: '/studentCourse', name: 'StudentCourse', component: StudentCourse,
            children: [
                { // 学生端课程公告
                    path: 'studentCourseNotice',
                    name: 'StudentCourseNotice',
                    component: () => import('@/components/excellentCourse/student/studentCourseNotice.vue')
                },
                {//学生端考核标准
                    path: 'studentExamStandard',
                    name: 'StudentExamStandard',
                    component: () => import('@/components/excellentCourse/student/studentExamStandard.vue')
                },
                { // 学生考试列表
                    path: 'jStudentExam',
                    name: 'jStudentExam',
                    component: () => import('@/components/excellentCourse/student/jExam/index.vue'),
                },
                { // 学生测试列表
                    path: 'jStudentTest',
                    name: 'jStudentTest',
                    component: () => import('@/components/excellentCourse/student/jExam/index.vue'),
                },
                { // 学生作答
                    path: 'jStudentExamAnswer',
                    name: 'jStudentExamAnswer',
                    component: () => import('@/components/excellentCourse/student/jExam/answer.vue'),
                },
                { // 学生作答详情
                    path: 'jStudentExamAnswerDetail',
                    name: 'jStudentExamAnswerDetail',
                    component: () => import('@/components/excellentCourse/student/jExam/answerDetail.vue'),
                },
                {// 学生互动讨论列表
                    path: 'studentThemeDiscuss',
                    name: 'studentThemeDiscuss',
                    component: () => import('@/components/excellentCourse/student/studentThemeDiscuss.vue')
                },
                {//  互动讨论详情
                    path: 'studentThemeDiscussDetails',
                    name: 'studentThemeDiscussDetails',
                    component: () => import('@/components/excellentCourse/components/themeDiscussDetails.vue')
                },
                {  // 课件
                    path: 'studentStudyProgress',
                    name: 'StudentStudyProgress',
                    component: () => import('@/components/excellentCourse/student/studentStudyProgress.vue')
                },
                {  // 作业
                    path: 'jHomeWork',
                    name: 'studentHomeWork',
                    component: () => import('@/components/excellentCourse/student/studentHomeWork.vue')
                },
                {  // 分享
                    path: 'studentShare',
                    name: 'studentShare',
                    component: () => import('@/components/excellentCourse/student/studentShare.vue')
                },
                { //  分享详情
                  path: 'studentShareDetails',
                  name: 'studentShareDetails',
                  component: () => import('@/components/excellentCourse/components/studentShareDetails.vue')
                },
            ]
        },

        // 精品课 - 考测相关页面
        {
            path: '/viewExercise',
            name: 'viewExercise',
            component: () => import('@/components/excellentCourse/courseIntroduction/components/jExam/viewExercise.vue'),
        },
        {
            path: '/editExercise',
            name: 'editExercise',
            component: () => import('@/components/excellentCourse/courseIntroduction/components/jExam/editExercise.vue'),
        },
        {
            path: '/examinationPaperView',
            name: 'examinationPaperView',
            component: () => import('@/components/excellentCourse/courseIntroduction/components/jExam/examinationPaperView.vue'),
        },
        {
            path: '/examPaperStudentConsult',
            name: 'examPaperStudentConsult',
            component: () => import('@/components/excellentCourse/courseIntroduction/components/jExam/testPaperStudentConsult.vue')
        },
        {
            path: '/jTestPaperStudentConsult',
            name: 'jTestPaperStudentConsult',
            component: () => import('@/components/excellentCourse/courseIntroduction/components/jExam/testPaperStudentConsult'),
        },
        // 批阅
        {
            path: '/examReadOver',
            name: 'examReadOver',
            component: () => import('@/components/excellentCourse/courseIntroduction/components/jExam/read-over/examrReadOver.vue'),
        },
        preciseReview,
        // 404 page must be placed at the end !!!
        {path: '*', redirect: '/404', hidden: true},
        // {// 学生端顶部信息
        //   path: '/studentCourseTop',
        //   name: 'StudentCourseTop',
        //   component: () => import('@/components/excellentCourse/student/studentCourseTop.vue')
        // },

        ...tarAdminRouter
    ]
})




// WEBPACK FOOTER //
// ./src/router/index.js